module.exports = __webpack_public_path__ + "static/media/succesContract.858ddd6a.svg";